<template>
  <div
    class="
      garden-help-forget-password
      garden-help-auth-container
      garden-help-auth-bg-container
    "
  >
    <div class="h-100">
      <div class="row h-100 m-0 authRowContainer">
        <div class="col-xl-4 col-lg-6 col-md-9 col-sm-12 mx-auto my-auto">
          <ResetPasswordCode
            welcomeHeader="Reset password"
            welcomeSubheader="Please enter the code that you have received"
            logoSrc="garden-help/Logo.png"
            guard="GARDENHELP"
            clientLink="garden_help"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ResetPasswordCode from "@/components/auth/ResetPasswordCode.vue";

export default {
  name: "GardenHelpResetPasswordCode",
  components: { ResetPasswordCode },
  data() {
    return {};
  },
  methods: {
    onSubmit() {
      console.log("submit forget password");
    },
  },
};
</script>
<style  scoped::v-deep>
@import "../styles/garden-help-auth-styles.css";
</style>



// WEBPACK FOOTER //
// src/projects/garden_help/auth/ResetPasswordCodeView.vue